import { useState, useMemo } from "react";

import Image from "./image/component";
import image_christmas_bayreuth from "./image_christmas_bayreuth.jpg";
import image_george_in_action from "./image_george_in_action.jpg";
import image_new_years_eve_nuernberg from "./image_new_years_eve_nuernberg.jpg";
import image_bride_kidnapping_unplugged_bayreuth from "./image_bride_kidnapping_unplugged_bayreuth.jpg";

const Images = () => {
  function next() {
    let next = current + 1;
    if(next >= images.length) next = 0;
    setCurrent(next);
  }
  function previous() {
    let prev = current - 1;
    if(prev < 0) prev = images.length - 1;
    setCurrent(prev);
  }
  
  const images = [
    <Image
        image={image_bride_kidnapping_unplugged_bayreuth}
        caption="Brautentführung/Brautstehlen/Brautverziehen unplugged in Bayreuth"
        previous={previous}
        next={next}
      />,
      <Image
        image={image_george_in_action}
        caption="Schlagzeuger George bei Hochzeit in Bayreuth"
        previous={previous}
        next={next}
      />,
      <Image
        image={image_new_years_eve_nuernberg}
        caption="Der Bühnenaufbau (Nürnberg Silvestergala)"
        previous={previous}
        next={next}
      />,
      <Image
        image={image_christmas_bayreuth}
        caption="Als Duo auf einer Weihnachtsfeier in Bayreuth"
        previous={previous}
        next={next}
      />
  ]
  
  const [current, setCurrent] = useState(0);

  const image = useMemo(() => {
    return images[current];
  }, [current]);

  return (
    <div id="container">
      {image}
      <div style={{ height: '15px' }}></div>
    </div>
  );
};

export default Images;
